/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from client/pages/terms/ambassadors.tsx.
// Do not edit it manually.

import type __GeneratedRouteApp from "@/client/index";

/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';

// Core

// App components
import { Link } from '@client/components';
import Page from '@/client/pages/_layout/_page';

/*----------------------------------
- TABS
----------------------------------*/
const TermsTabs = ({
  current
}: {
  current: 'tools' | 'marketplace' | 'csm' | 'teamLeader' | 'businessPartner' | 'dealPartner' | 'ambassadors';
}) => {
  const base = 'px-4 py-2 rounded-lg text-sm font-semibold transition-colors';
  const active = 'bg-gradient-to-r from-orange-500 to-pink-500 text-white shadow';
  const inactive = 'text-slate-700 hover:text-orange-600 hover:bg-orange-50';
  return <div className="flex flex-wrap items-center gap-2 bg-orange-50 border border-orange-100 rounded-xl p-2">
            <Link to="/terms" className={`${base} ${current === 'tools' ? active : inactive}`}>
                Tools
            </Link>
            <Link to="/terms/marketplace" className={`${base} ${current === 'marketplace' ? active : inactive}`}>
                Marketplace
            </Link>
            <Link to="/terms/csm" className={`${base} ${current === 'csm' ? active : inactive}`}>
                CSM
            </Link>
            <Link to="/terms/team-leader" className={`${base} ${current === 'teamLeader' ? active : inactive}`}>
                Team Leader
            </Link>
            <Link to="/terms/business-partner" className={`${base} ${current === 'businessPartner' ? active : inactive}`}>
                Business Partner
            </Link>
            <Link to="/terms/deal-partner" className={`${base} ${current === 'dealPartner' ? active : inactive}`}>
                Deal Partner
            </Link>
            <Link to="/terms/ambassadors" className={`${base} ${current === 'ambassadors' ? active : inactive}`}>
                Ambassadors
            </Link>
        </div>;
};

/*----------------------------------
- PAGE: AMBASSADORS TERMS
----------------------------------*/

export const __register = (app: __GeneratedRouteApp) => {
  const { Router } = app;
  return Router.page('/terms/ambassadors', { ...({
  static: {
    refresh: '1h',
    urls: ['/terms/ambassadors']
  }
}), ...{ filepath: "/app/client/pages/terms/ambassadors.tsx", sourceLocation: { line: 54, column: 1 }, id: "terms_ambassadors" } }, null, ({}) => {
  return <Page mainClassName="pt-28 pb-20 px-6 lg:px-8 bg-gradient-to-br from-orange-50 via-white to-pink-50">
            <div className="max-w-4xl mx-auto">
                <div className="mb-6">
                    <TermsTabs current="ambassadors" />
                </div>

                <div className="bg-white rounded-2xl shadow-lg border border-orange-100 p-8 md:p-10">
                    <h1 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent mb-2">
                        CrossPath Ambassadors – Terms & Conditions
                    </h1>
                    <p className="text-slate-600 text-sm mb-8">
                        <em>Last Updated: 21/08/25</em>
                    </p>

                    <div className="prose prose-slate max-w-none">
                        <h2 className="text-xl font-bold text-slate-900 mb-2">1. Definitions</h2>
                        <ul className="list-disc pl-6 text-slate-700 mb-6">
                            <li>
                                <strong>Ambassador</strong>: An individual or entity promoting Cross&nbsp;Path
                                Prospector ("Prospector") using a unique referral link provided by Cross Path Network
                                Ltd ("Cross Path").
                            </li>
                            <li>
                                <strong>Referred Customer</strong>: A person or business who clicks an Ambassador's link
                                and subscribes to Prospector within <strong>90 days</strong>.
                            </li>
                            <li>
                                <strong>Ongoing Account</strong>: A referred customer whose subscription remains active
                                and continues beyond 30 days from the start date. Subscriptions canceled, terminated, or
                                still within the first 30 days are not counted as ongoing accounts.
                            </li>
                            <li>
                                <strong>Commission</strong>: A percentage of net subscription revenue (excluding VAT,
                                discounts, refunds, chargebacks).
                            </li>
                            <li>
                                <strong>Level</strong>: Ambassador's commission level based on the count of active
                                Ongoing Accounts.
                            </li>
                        </ul>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">2. No MLM Structure</h2>
                        <p className="text-slate-700 mb-6">
                            This is a <strong>one-tier program</strong>&mdash;no multi-level or sub-tier tracking; only
                            direct referrals are eligible.
                        </p>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">
                            3. Referral Tracking &amp; Eligibility
                        </h2>
                        <ul className="list-disc pl-6 text-slate-700 mb-6">
                            <li>Only clicks on Ambassador-specific referral links are tracked.</li>
                            <li>Referred Customers must not be existing or previously subscribed users.</li>
                            <li>Only the last click within the 90-day cookie period qualifies for commissions.</li>
                            <li>
                                Cross&nbsp;Path reserves the right to invalidate fake, fraudulent, or self-referrals.
                            </li>
                        </ul>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">4. Commission Structure</h2>
                        <p className="text-slate-700 mb-4">
                            Applicable commission tiers are confirmed in the Ambassador agreement for each eligible
                            referred customer relationship.
                        </p>

                        <p className="text-slate-700 mb-4">
                            Tier labels and eligibility rules are tracked in the Ambassador dashboard and may vary by
                            campaign, geography, and customer segment.
                        </p>

                        <ul className="list-disc pl-6 text-slate-700 mb-6">
                            <li>
                                First-month commission paid retroactively if subscription stays active beyond 30 days;
                                voided if canceled earlier.
                            </li>
                        </ul>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">
                            5. Commission Payments &amp; Clawbacks
                        </h2>
                        <ul className="list-disc pl-6 text-slate-700 mb-6">
                            <li>
                                Commissions are paid in <strong>cash</strong> via Stripe through our in-house platform.
                            </li>
                            <li>
                                Each commission is paid <strong>within 31 days</strong> of Cross&nbsp;Path collecting
                                full payment from the Referred Customer.
                            </li>
                            <li>
                                Commission payments are confirmed in the Ambassador dashboard, which serves as official
                                documentation.
                            </li>
                            <li>
                                Clawbacks apply for refunds or chargebacks: Cross&nbsp;Path may deduct from future
                                commissions or invoice the Ambassador.
                            </li>
                        </ul>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">6. Marketing Guidelines</h2>
                        <ul className="list-disc pl-6 text-slate-700 mb-6">
                            <li>Ambassadors must use only approved branding and promotional materials.</li>
                            <li>
                                Prohibited behaviors include misleading claims, spam, fake leads/reviews, bidding on
                                branded keywords, etc.
                            </li>
                            <li>
                                Ambassadors must clearly disclose their relationship with Cross&nbsp;Path per UK
                                advertising rules.
                            </li>
                        </ul>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">7. Recordkeeping &amp; Audits</h2>
                        <ul className="list-disc pl-6 text-slate-700 mb-6">
                            <li>
                                Ambassadors must retain referral data and marketing records for <strong>3 years</strong>
                                .
                            </li>
                            <li>
                                Cross&nbsp;Path may audit records to ensure compliance and may request documents or
                                proof.
                            </li>
                        </ul>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">8. Confidentiality &amp; IP</h2>
                        <ul className="list-disc pl-6 text-slate-700 mb-6">
                            <li>Cross&nbsp;Path owns all intellectual property and marketing materials provided.</li>
                            <li>
                                Ambassadors may only use such materials for program purposes, and must not publicly
                                disparage Cross&nbsp;Path.
                            </li>
                        </ul>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">9. Indemnity</h2>
                        <p className="text-slate-700 mb-6">
                            Ambassadors agree to indemnify Cross&nbsp;Path for claims arising from their marketing
                            actions, including legal violations or consumer complaints.
                        </p>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">10. Modifications &amp; Termination</h2>
                        <ul className="list-disc pl-6 text-slate-700 mb-6">
                            <li>
                                Cross&nbsp;Path may update terms, tiers, or program rules at its discretion; changes
                                take effect upon posting.
                            </li>
                            <li>Ambassadors or Cross&nbsp;Path may terminate participation at any time.</li>
                            <li>No commissions accrue post-termination.</li>
                        </ul>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">11. Legal Relationship</h2>
                        <ul className="list-disc pl-6 text-slate-700 mb-6">
                            <li>Ambassadors act as independent contractors, not employees or agents.</li>
                            <li>No joint venture or employment is created by these terms.</li>
                        </ul>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">
                            12. Governing Law &amp; Dispute Resolution
                        </h2>
                        <ul className="list-disc pl-6 text-slate-700 mb-6">
                            <li>
                                These Terms are governed by the laws of <strong>England and Wales</strong>.
                            </li>
                            <li>
                                Disputes are subject to the courts in <strong>England</strong>.
                            </li>
                        </ul>

                        <h2 className="text-xl font-bold text-slate-900 mb-2">13. Support &amp; Administration</h2>
                        <ul className="list-disc pl-6 text-slate-700 mb-0">
                            <li>
                                Commissions, link tracking, and performance metrics are accessible via Ambassador
                                dashboard.
                            </li>
                            <li>
                                For queries or support, email:{' '}
                                <a href="mailto:ambassador@becrosspath.com">
                                    <strong>ambassador@becrosspath.com</strong>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </Page>;
});
};
